import React, { Component } from 'react';
import { NavItem, NavLink,Nav } from 'reactstrap';
import classnames from 'classnames';
class SectionList extends Component {
    constructor(props) {
      super(props);
      this.state = {
        items: [],
        activeTab:'',
      };
    }

    componentDidUpdate(prevProps) {
        const {sectionData} = this.props;
        if (sectionData !== prevProps.sectionData) {
            this.setState({
                items: sectionData
            })
        }
    }

    handleToggle=(item,computedSectionId)=>{
        this.setState({
            activeTab:computedSectionId
        })
        this.props.handleToggle(item,computedSectionId)      
    }

    handleDefault=(data)=>{
      if(data.length){
        this.handleToggle(data[0], data[0].computedSectionId)
      }
    }

    render() {
        return (
            <div>
                {(this.state.activeTab === '')?this.handleDefault(this.state.items):""}
                {(this.state.items)?this.state.items.map((item, index) => (
                    <Nav key={item.computedSectionId} tabs>
                    <NavItem key={item.computedSectionId} className='tabs-style'>
                        <NavLink key={item.computedSectionId}
                            className={classnames({ active: this.state.activeTab ===  item.computedSectionId})}
                            onClick={(e) => this.handleToggle(item, item.computedSectionId)}>
                            {item.reportDisplayName==null?item.displayName:item.reportDisplayName} 
                        </NavLink>
                    </NavItem>
                    </Nav>
                )):""}
          </div>
        );
    }
}

export default SectionList;